$isFrozen